import { Box } from "@mui/material";
import React from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import { FilterButton } from "../../Button/FilterButton";
import { PrintButton } from "../../Button/PrintButton";
import { RefreshButton } from "../../Button/RefreshButton";

interface ListActionButtonsProps {
    filterIsSet?: boolean;
    filterDisabled?: boolean;
    printDisabled?: boolean;
    refreshDisabled?: boolean;
    onFilter?: () => void;
    onPrint?: () => void;
    onRefresh?: () => void;
}

export const ListActionButtons = ({
    filterIsSet,
    filterDisabled,
    printDisabled,
    refreshDisabled,
    onFilter,
    onPrint,
    onRefresh,
}: ListActionButtonsProps) => (
    <Box display="flex" sx={{ marginRight: ".5rem" }}>
        {onFilter
            ? (
                <FilterButton onClick={onFilter} disabled={filterDisabled} iconcolor={filterIsSet ? "warning" : "inherit"}>
                    {Translations.FilterCondition}
                </FilterButton>
            )
            : null}
        {onPrint
            ? (
                <PrintButton onClick={onPrint} sx={{ marginLeft: ".5rem" }} disabled={printDisabled}>
                    {Translations.Print}
                </PrintButton>
            )
            : null}
        {onRefresh
            ? (
                <RefreshButton onClick={onRefresh} sx={{ marginLeft: ".5rem" }} disabled={refreshDisabled}>
                    {Translations.RefreshList}
                </RefreshButton>
            )
            : null}
    </Box>
);
